import React from 'react';
import './DarkModeButton.scss';

const DarkModeButton = ({
  text,
  onClick = () => {},
  type = 'button',
  variant='default',
 ...props
}) => {
  const handleClick = (e) => {
    onClick(e);
  };

  return (
    <button
      type={type}
      className={`dark-mode-button  ${variant}`}
      onClick={handleClick}
      {...props}
    >
      <span className="action-button-text">
        {text}
      </span>
    </button>
  );
};

export default DarkModeButton;
